/* eslint-disable max-len */
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrivateContentInformerModule } from '@app/collections/shared/private-content-informer/private-content-informer.module';
import { CommentsModule } from '@app/core/components/comments/comments.module';
import { SpinnersModule } from '@app/core/components/spinners/spinners.module';
import { TitleModule } from '@app/core/components/title/title.module';
import { tinyMCEScriptSrc } from '@app/core/components/wyisiwyg-editor/tinymce.config';
import { PipesModule } from '@app/core/pipes/pipes.module';
import { GamesModule } from '@app/games/games.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { ContentMetaModule } from '@app/library/content-card/content-meta/content-meta.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { CoreModule } from '@core/core.module';

import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { SharedModalModule } from '@shared/shared-modal.module';
import { EditorModule as TinymceModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { DateFnsModule, FormatDistanceToNowStrictPurePipeModule } from 'lingo2-ngx-date-fns';
import { InViewportModule } from 'ng-in-viewport';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClipboardModule } from 'ngx-clipboard';
import {
  OnUiAudioPlayerModule,
  OnUiButtonModule,
  OnUiCardMenuModule,
  OnUiCoverModule,
  OnUiSelectModule,
} from 'onclass-ui';
import { ArticleCardComponent } from './content-card/article-card/article-card.component';
import { LessonCardComponent } from './content-card/lesson-card/lesson-card.component';
import { MediaCardComponent } from './content-card/media-card/media-card.component';
import { MicroTextCardComponent } from './content-card/microtext-card/microText-card.component';
import { VocabularyCardComponent } from './content-card/vocabulary-card/vocabulary-card.component';
import { VocabularyOptionsComponent } from './content-card/vocabulary-card/vocabulary-options/vocabulary-options.component';
import { VocabularyPlaymodeComponent } from './content-card/vocabulary-card/vocabulary-playmode/vocabulary-playmode.component';
import { ArticleCardMiniComponent } from './content-card-mini/article-card-mini/article-card-mini.component';
import { AudioCardMiniComponent } from './content-card-mini/audio-card-mini/audio-card-mini.component';
import { ContentCardMiniComponent } from './content-card-mini/content-card-mini.component';
import { ImageCardMiniComponent } from './content-card-mini/image-card-mini/image-card-mini.component';
import { LessonCardMiniComponent } from './content-card-mini/lesson-card-mini/lesson-card-mini.component';
import { VideoCardMiniComponent } from './content-card-mini/video-card-mini/video-card-mini.component';
import { VocabularyCardMiniComponent } from './content-card-mini/vocabulary-card-mini/vocabulary-card-mini.component';
import { ContentCardMiniListComponent } from './content-card-mini-list/content-card-mini-list.component';
import { ContentDragScrollComponent } from './content-drag-scroll/content-drag-scroll.component';
import { LibrarySortingComponent } from './library-sorting/library-sorting.component';
import { LibraryTitleComponent } from './library-title/library-title.component';
import { ShareAndStatsComponent } from './share-and-stats/share-and-stats.component';

@NgModule({
  imports: [
    LocaleSharedModule,
    CommonModule,
    CommentsModule,
    ClipboardModule,
    DateFnsModule,
    GamesModule,
    TitleModule,

    SharedModalModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    SpinnersModule,
    TinymceModule,
    PipesModule,
    LazyLoadImageModule,
    ComplaintFormModule,
    InViewportModule,
    ContentMetaModule,
    PrivateContentInformerModule,
    OnUiCoverModule,
    OnUiButtonModule,
    OnUiCardMenuModule,
    AlertModule,
    BookmarkComponent,
    SubscribeComponent,
    CoreModule,
    OnUiSelectModule,
    OnUiAudioPlayerModule,
    RatingComponent,
    ContentCardModule,
    IconComponent,
    FormatDistanceToNowStrictPurePipeModule,
    AuthorInfoComponent,
  ],
  exports: [
    ContentCardMiniListComponent,
    ContentCardMiniComponent,
    ContentDragScrollComponent,
    LibraryTitleComponent,
    LibrarySortingComponent,
    LessonCardMiniComponent,
    VideoCardMiniComponent,
    AudioCardMiniComponent,
    ArticleCardMiniComponent,
    ImageCardMiniComponent,
    VocabularyCardMiniComponent,
  ],
  declarations: [
    ShareAndStatsComponent,
    LibraryTitleComponent,
    LibrarySortingComponent,
    ContentDragScrollComponent,
    VocabularyOptionsComponent,
    VocabularyPlaymodeComponent,
    LessonCardComponent,
    MediaCardComponent,
    ArticleCardComponent,
    MicroTextCardComponent,
    VocabularyCardComponent,
    ContentCardMiniComponent,
    ContentCardMiniListComponent,
    LessonCardMiniComponent,
    VideoCardMiniComponent,
    AudioCardMiniComponent,
    ArticleCardMiniComponent,
    ImageCardMiniComponent,
    VocabularyCardMiniComponent,
  ],
  providers: [
    // @see /angular.json: [architect.build.assets]: { 'glob': '**/*', 'input': 'node_modules/lingo2-tinymce-custom', 'output': '/editor/' }
    { provide: TINYMCE_SCRIPT_SRC, useValue: tinyMCEScriptSrc },
  ],
})
export class LibraryElementsModule {}
